export enum GlobalClassName {
  Body = 'g-body',

  Brand = 'g-brand',
  Logo = 'g-logo',
  LogoImg = 'g-logo-img',
  Title = 'g-title',

  Header = 'g-header',
  HeaderTopNavbar = 'g-header-top-navbar',
  HeaderTopNavbarLeft = 'g-header-top-navbar-left',
  HeaderTopNavbarLeftItem = 'g-header-top-navbar-left-item',
  HeaderTopNavbarLeftItemActive = 'g-header-top-navbar-left-item-active',
  HeaderTopNavbarRight = 'g-header-top-navbar-right',
  HeaderTopNavbarRightItem = 'g-header-top-navbar-right-item',
  HeaderSecondlyNavbar = 'g-header-secondly-navbar',
  HeaderSecondlyNavbarItem = 'g-header-secondly-navbar-item',
  HeaderSecondlyNavbarItemActive = 'g-header-secondly-navbar-item-active',
  HeaderTertiaryNavbar = 'g-header-tertiary-navbar',
  HeaderTertiaryNavbarItem = 'g-header-tertiary-navbar-item',
  HeaderTertiaryNavbarItemActive = 'g-header-tertiary-navbar-item-active',

  Sidebar = 'g-sidebar',
  SidebarMenu = 'g-sidebar-menu',
  SidebarItemCategory = 'g-sidebar-item-category',
  SidebarItemList = 'g-sidebar-item-list',
  SidebarItemLink = 'g-sidebar-item-link',
  SidebarItemLinkActive = 'g-sidebar-item-link-active',
  SidebarSection = 'g-sidebar-section',
  SidebarSectionHeading = 'g-sidebar-section-heading',
}
